import { render, staticRenderFns } from "./studentParticular.vue?vue&type=template&id=72ff981b&scoped=true"
import script from "./studentParticular.vue?vue&type=script&lang=js"
export * from "./studentParticular.vue?vue&type=script&lang=js"
import style0 from "./studentParticular.vue?vue&type=style&index=0&id=72ff981b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff981b",
  null
  
)

export default component.exports